import { useLoaderData } from 'react-router';
import { paths } from '../../../../../common/constants/pathVariables.js';
import { CocoOrderType, RelatedPartyRoles } from '../../../../../common/enums.js';
import { changeOrderMsg, omaElisaForCompaniesMsg, orderMsg, ordersMsg, t } from '../../../../../common/i18n/index.js';
import { getLocalizedDateString } from '../../../../../common/utils/dateUtils.js';
import { BreadCrumbsWithTitle } from '../../../../../components/BreadCrumbsWithTitle/BreadCrumbsWithTitle.js';
import { ChangeOrderContentCoCo } from '../../../../../components/CustomerOrderDetails/ChangeOrderContentCoCo.js';
import { NewOrderContentCoCo } from '../../../../../components/CustomerOrderDetails/NewOrderContentCoCo.js';
import { DetailsWrapper } from '../../../../../components/DetailsWrapper/index.js';
import type { CocoProductOrderDetail } from '../../../../../generated/api/cocoProductOrderDetail.js';

export const OrderPathCoCo = () => {
  const order = useLoaderData() as CocoProductOrderDetail;
  const isNewOrder = order.orderType === CocoOrderType.NEW_ORDER;
  const heading = order.externalIdentifier ?? order.id;
  const customerName = order.relatedParty?.find(party => party.role === RelatedPartyRoles.CUSTOMER)?.name;
  const headingBottom = [isNewOrder ? null : heading, getLocalizedDateString(new Date(order.created)), customerName]
    .filter(Boolean)
    .join(' | ');

  return (
    <DetailsWrapper
      classes={['of-customer-order-details']}
      detailsTop={
        <BreadCrumbsWithTitle
          breadCrumbPaths={[
            { name: t.VCUZ(omaElisaForCompaniesMsg), path: paths.SELF_SERVICE_HOME },
            { name: t.I9C0(ordersMsg), path: paths.CUSTOMER_ORDERS },
            { name: heading },
          ]}
        />
      }
      headingTop={isNewOrder ? t.C001(orderMsg) : ''}
      heading={isNewOrder ? heading : t.PZ9O(changeOrderMsg)}
      headingBottom={headingBottom}
      id={`coco-order-details-${order.id}`}
    >
      {isNewOrder ? <NewOrderContentCoCo order={order} /> : <ChangeOrderContentCoCo order={order} />}
    </DetailsWrapper>
  );
};
